import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import { targetedenergyList } from "variables/lists/action";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {}, [isRefetched]);

  useEffect(() => {
    getSavings();
  }, [isRefetched, action.parameters?.impact?.targetedenergy]);

  const getSavings = async (route) => {
    setStructureData(action.parameters?.impact?.targetedenergy || []);
  };

  // ----------------------------------------------------------

  const handleCheckboxChange = (e, key) => {
    let newArray = action.parameters?.impact?.[key] || [];

    if (
      e.props.value.includes("all") &&
      targetedenergyList.length !== newArray.length
    ) {
      newArray = targetedenergyList;
    } else if (e.props.value.includes("all")) {
      newArray = [];
    } else if (newArray.find((n) => n.id == e.props.value) == undefined) {
      newArray.push({
        name: targetedenergyList.find((n) => n.id == e.props.value).name,
        id: e.props.value,
      });
    } else {
      newArray = newArray.filter((x) => {
        return x.id != e.props.value;
      });
    }

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          [key]: newArray,
        },
      },
    }));
  };

  const SubHeaderComponent = () => {
    return (
      <>
        <TableName></TableName>
        {/* <EditButton handleSubmit={handleSimulate}>Simuler</EditButton> */}

        {actionplanadmin && (
          <MultiselectCheckbox
            inputTitle="Selection de fluides"
            selected={action.parameters?.impact?.targetedenergy || []}
            list={targetedenergyList}
            handleChange={(_, newValue) =>
              handleCheckboxChange(newValue, "targetedenergy")
            }
            primary="Tous les fluides"
            width="11rem"
          />
        )}
      </>
    );
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: <SubHeaderComponent />,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
    },
    refreshTable,
  };
}
